// Class: openfl.display.IGraphicsData

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IGraphicsData = function() {}

// Meta

IGraphicsData.__name__ = "openfl.display.IGraphicsData";
IGraphicsData.__isInterface__ = true;
IGraphicsData.prototype = {
	
};
IGraphicsData.prototype.__class__ = IGraphicsData.prototype.constructor = $hxClasses["openfl.display.IGraphicsData"] = IGraphicsData;

// Init



// Statics




// Export

exports.default = IGraphicsData;